// extracted by mini-css-extract-plugin
export default {"form":"RegisterComponent_form__Obl2H","formGroup":"RegisterComponent_formGroup__JvSxC"};